"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CASHBACK_TEXT = void 0;
const CASHBACK_TEXT = exports.CASHBACK_TEXT = 'cashback-text';
//# sourceMappingURL=constants.js.map